<template>
  <div class="container">
    <div class="h-top">
      <h1 class="h-header animated fadeInDown">{{ $t("gallery") }}</h1>
      <div class="animated fadeInUp">
        <p class="h-paragraph h-width-sm">{{ $t("galleryInfo") }}</p>
        <p class="h-paragraph h-width-xs">{{ $t("galleryPick") }}</p>
      </div>
    </div>
    <div class="gallery-holder">
      <gallery-list class="animated fadeInUp list"/>
      <gallery-info class="animated fadeIn info"/>
    </div>
    <base-bottom/>
  </div>
</template>

<script>
import GalleryList from "@/components/Gallery/Gallery-List";
import GalleryInfo from "@/components/Gallery/Gallery-Info";
export default {
  components: {
    GalleryList,
    GalleryInfo
  }
};
</script>

<style lang="scss" scoped>
.gallery-holder {
  width: 100%;
  @include flex(flex-start, flex-start, row);
  @include respond(tab-land) {
    @include flex(center, center, column);
  }
}
.list {
  width: 30%;
  @include respond(tab-port) {
    width: 100%;
  }
  @include respond(phone) {
    width: 100%;
  }
}
.info {
  margin-left: 5%;
  width: 65%;
  @include respond(tab-port) {
    width: 100%;
  }
  @include respond(phone) {
    width: 100%;
    margin-left: 0;
  }
}
</style>
